var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCash24 = function SvgCash24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor",
    fillOpacity: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11a5.001 5.001 0 0 1-3.036 4.6A5 5 0 0 1 14 20H7a5 5 0 0 1-5-5v-2a5.002 5.002 0 0 1 4.084-4.916A5.002 5.002 0 0 1 11 4h6a5 5 0 0 1 5 5v2Zm-8 7a3.001 3.001 0 0 0 2.83-2H11a5 5 0 0 1-5-5v-.83A3.001 3.001 0 0 0 4 13v2a3 3 0 0 0 3 3h7Zm-6-7V9.001A3 3 0 0 1 11 6h6a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3Z",
    fill: "currentColor",
    fillOpacity: 0.64
  })));
};
export default SvgCash24;